import { format } from 'd3-format';
import * as moment from 'moment-timezone';
import { scaleUtc } from 'd3-scale';
import { quantile } from 'd3-array';
export const formatMetricValue = (value) => {
    if (typeof value !== 'number' || isNaN(value)) {
        return 'N/A';
    }
    else if (Math.abs(value) >= Math.pow(10, 25)) {
        return format('-.3~e')(value);
    }
    else {
        return format('-.3~s')(value);
    }
};
export const dateTimeTickFormatter = (d) => {
    const m = moment(d);
    if (m.clone().startOf('day').unix() === m.unix()) {
        return [m.format('HH:mm'), m.format('MMM DD')];
    }
    else {
        return [m.format('HH:mm')];
    }
};
export const calculateDateTimeTicks = (millisSet) => {
    const minMillis = millisSet[0];
    const maxMillis = millisSet[millisSet.length - 1];
    const offsetMillis = moment(minMillis).utcOffset() * 60000;
    const minMillisShifted = minMillis + offsetMillis;
    const maxMillisShifted = maxMillis + offsetMillis;
    const scale = scaleUtc().domain([new Date(minMillisShifted), new Date(maxMillisShifted)]);
    const ticks = scale.ticks(6).map((d) => d.valueOf() - offsetMillis);
    return ticks;
};
export const calculateSummaryStatistics = (values) => {
    const output = {
        min: {
            value: quantile(values, 0.0),
            label: 'Minimum',
        },
        q1area: {
            value: quantile(values, 0.25),
            label: '25th %-ile',
        },
        median: {
            value: quantile(values, 0.5),
            label: 'Median',
        },
        q3area: {
            value: quantile(values, 0.75),
            label: '75th %-ile',
        },
        max: {
            value: quantile(values, 1.0),
            label: 'Maximum',
        },
    };
    return output;
};
//# sourceMappingURL=data:application/json;base64,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